import type { LucideIcon } from 'lucide-react';

import {
  BarChart,
  Box,
  Calculator,
  Circle,
  CircleDot,
  Cone,
  Cylinder,
  Dice6,
  FileText,
  Hash,
  Infinity,
  Pi,
  PieChart,
  Pyramid,
  Radical,
  Sigma,
  SquareFunction,
  Tangent,
  Target,
  TrendingUp,
  Triangle,
  Variable,
  Waves,
} from 'lucide-react';

import type { ConceptMetadata } from '../constants/concept-index';

// Icon name to Lucide component mapping
const ICON_COMPONENTS: Record<string, LucideIcon> = {
  BarChart,
  Box,
  Calculator,
  Circle,
  CircleDot,
  Cone,
  Cylinder,
  Dice6,
  FileText,
  Hash,
  Infinity,
  Pi,
  PieChart,
  Pyramid,
  Radical,
  Sigma,
  SquareFunction,
  Tangent,
  Target,
  TrendingUp,
  Triangle,
  Variable,
  Waves,
};

/**
 * Get the Lucide icon component for a concept using its pre-computed icon name
 * This ensures consistent server/client rendering and optimal performance
 */
export function getConceptIcon(concept: ConceptMetadata): LucideIcon {
  if (!concept?.iconName) {
    return Calculator;
  }

  return ICON_COMPONENTS[concept.iconName] || Calculator;
}

// For backward compatibility, export the same function with the cached name
export const getConceptIconCached = getConceptIcon;

// Utility function for analytics/debugging
export function getIconStats(
  concepts: ConceptMetadata[]
): Record<string, number> {
  const stats: Record<string, number> = {};

  for (const concept of concepts) {
    const iconName = concept?.iconName || 'Calculator';
    stats[iconName] = (stats[iconName] || 0) + 1;
  }

  return stats;
}
